import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type EmailVerificationCodeSerializer = {
  email: string;
  email_sent: boolean;
  message: string;
};

export type PostEmailVerificationCodePayloadType = (
  Pick<EmailVerificationCodeSerializer, 'email'>
);
export type PostEmailVerificationCodeResponseType = (
  Pick<EmailVerificationCodeSerializer, 'email_sent' | 'message'>
);

export const apiRequestEmailVerificationCode = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostEmailVerificationCodePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('public');
    const res = await client.post({
      url: urls.v1.emailVerificationCode(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
